import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatSliderModule } from '@angular/material/slider';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TextControlComponent } from './controls/text-control.component';
import { BaseControlComponent } from './controls/base-control.component';
import { BaseComponent } from './base/base.component';
import { ButtonComponent } from './controls/button.component';
import { DialogComponent } from './controls/dialog.component';
import { ActionRowComponent } from './controls/action-row.component';
import { MatSelectModule } from '@angular/material/select';
import { TranslationPipe } from './pipes/translation.pipe';
import { TranslationClientCustomizationPipe } from './pipes/translation-client-customization.pipe';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';

@NgModule({
  declarations: [
    BaseControlComponent,
    BaseComponent,
    TextControlComponent,
    ButtonComponent,
    DialogComponent,
    ActionRowComponent,
    TranslationPipe,
    TranslationClientCustomizationPipe,
    SentenceCasePipe
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    MatRadioButton,
    MatRadioModule,
    MatError,
    MatDatepickerModule,
    MatOptionModule,
    MatSelectModule,
    MatDividerModule,
    ReactiveFormsModule,
    MatToolbarModule,
    RouterModule,
    MatCheckboxModule,
    FormsModule,
  ],
  exports: [
    BrowserAnimationsModule,
    MatSliderModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatRadioButton,
    MatRadioModule,
    MatDatepickerModule,
    MatOptionModule,
    MatSelectModule,
    MatDividerModule,
    MatError,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatToolbarModule,
    RouterModule,
    MatCheckboxModule,
    FormsModule,
    BaseComponent,
    BaseControlComponent,
    TextControlComponent,
    ButtonComponent,
    DialogComponent,
    ActionRowComponent,
    TranslationPipe,
    TranslationClientCustomizationPipe,
    SentenceCasePipe
  ],
  providers: [
    TitleCasePipe,
  ]
})
export class SharedModule {}
